import React from 'react';
import PropTypes from 'prop-types';
import {CallbackComponent} from 'redux-oidc';
import userManager from 'utils/userManager';
import {withRouter} from 'react-router';
import log from 'utils/logger';
import LoginPage from 'pages/LoginPage';

const logger = log('CallbackPage');

export class CallbackPage extends React.Component {

    constructor(props, context) {
        super(props, context);
        this.successCallback = this
            .successCallback
            .bind(this);

        this.errorCallback = this
            .errorCallback
            .bind(this);
        this.state = {
            errorMessage: null,
        };
    }

    componentDidMount() {
        this.time = setTimeout(() => this.setState({
            errorMessage: 'Something went wrong, try again.'
        }), 20 * 1000);
    }

    componentWillUnmount() {
        if (this.time) {
            clearTimeout(this.time);
        }
    }

    successCallback(user) {
        if (this.time) {
            clearTimeout(this.time);
        }
        logger.info(`Succefully logged in. User payload: ${user}`);

        if (user.state.redirectUrl === '/login') {
            this
                .props
                .history
                .push('/');
        } else {
            this
                .props
                .history
                .push(user.state.redirectUrl || '/');
        }

    }

    errorCallback(error) {
        if (this.time) {
            clearTimeout(this.time);
        }

        const message = error && error.error_description ?
            `${error.error_description} (${error.error})`
            :
            `Unexpected error during log in.`;
        this.setState({
            errorMessage: message,
        });
    }

    render() {

        const { errorMessage } = this.state;

        return (

            <div>
                <div className="container body-content">

                    <CallbackComponent
                        userManager={userManager}
                        successCallback={this.successCallback}
                        errorCallback={this.errorCallback}
                    >
                        <div>
                            {errorMessage ? (
                                <div>
                                    <div className="card-panel red-text text-darken-2">
                                        <p>{errorMessage}</p>
                                        <p>Please contact your supervisor for assistance.</p>
                                    </div>
                                    <LoginPage />
                                </div>
                            ) : (
                                    <h3>Redirecting...</h3>
                            )}
                        </div>

                    </CallbackComponent>

                </div>

            </div>
        );
    }
}

CallbackPage.propTypes = {
    history: PropTypes.object,
};

export default withRouter(CallbackPage);



// WEBPACK FOOTER //
// ./src/containers/pages/CallbackPage.js